import {Component, OnInit} from "@angular/core";
import {MessagesSettings} from "./components/messages.settings";
import {Message, MessageCollection} from "../shared/api/messages/api.models";

@Component({
    selector : 'add-message',
    template: require('./add.component.html')
})

export class AddMessageComponent implements OnInit {
    settings: MessagesSettings;
    messageCollection: MessageCollection;

    ngOnInit(): void {
        this.messageCollection     = new MessageCollection();
        this.messageCollection.messages.push(new Message());

        this.settings              = new MessagesSettings();
        this.settings.approvalMode = false;
    }

    done(): void {
        this.messageCollection     = new MessageCollection();
        this.messageCollection.messages.push(new Message());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/messages/add.component.ts